import React from 'react';
import { Navbar } from '../../components/landing/Navbar';
import { Hero } from '../../components/landing/Hero';
import { StatsBar } from '../../components/landing/StatsBar';
import { FeaturesSection } from '../../components/landing/FeaturesSection';
import { HowItWorksSection } from '../../components/landing/HowItWorksSection';
import { TestimonialsSection } from '../../components/landing/TestimonialsSection';
import { CTAFinal } from '../../components/landing/CTAFinal';
import { Footer } from '../../components/landing/Footer';

const Landing: React.FC = () => {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <StatsBar />
        <FeaturesSection />
        <HowItWorksSection />
        <TestimonialsSection />
        <CTAFinal />
      </main>
      <Footer />
    </>
  );
};

export default Landing;
